import { render, staticRenderFns } from "./DeleteMappingModal.vue?vue&type=template&id=4205ffd5&"
import script from "./DeleteMappingModal.vue?vue&type=script&lang=js&"
export * from "./DeleteMappingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports